var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8499 7.24987L9.24985 17.8499C9.15597 17.9445 9.02817 17.9978 8.89485 17.9978C8.76153 17.9978 8.63373 17.9445 8.53985 17.8499L3.14985 12.4599C3.05519 12.366 3.00195 12.2382 3.00195 12.1049C3.00195 11.9716 3.05519 11.8438 3.14985 11.7499L3.84985 11.0499C3.94373 10.9552 4.07153 10.902 4.20485 10.902C4.33817 10.902 4.46597 10.9552 4.55985 11.0499L8.88985 15.3799L18.4399 5.82987C18.6377 5.63809 18.952 5.63809 19.1499 5.82987L19.8499 6.53987C19.9445 6.63375 19.9978 6.76155 19.9978 6.89487C19.9978 7.02819 19.9445 7.15599 19.8499 7.24987Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.665538e967ccbae8e32958a936da9743.svg";
export { ForwardRef as ReactComponent };